import { render, staticRenderFns } from "./AssetTypeSummary.vue?vue&type=template&id=e0028606&"
import script from "./AssetTypeSummary.vue?vue&type=script&lang=ts&"
export * from "./AssetTypeSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports